import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import Title from '../../../components/Title';
import Breadcrumbs from '../../../components/Breadcrumbs';
import ArticleFilter from './dataGrid/ArticleFilter';
import ArticleDataGrid from './dataGrid/ArticleDataGrid';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import * as Actions from '../redux/articleActions';
import * as Selectors from '../redux/articleSelectors';
import { ArticleParams } from '../model/articleModel';
import * as CommonSelectors from '../../../shared/redux/commonSelectors';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';

const breadcrumbs = [
  {
    label: 'article.manage',
    to: null,
  },
];

const ArticleList: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams<ArticleParams>();
  const apiRequestState = useSelector(Selectors.apiArticlesRequestState);
  const apiRequestError = useSelector(Selectors.apiArticlesRequestError);
  const rootCategory = useSelector(CommonSelectors.rootCategory);
  const category = useSelector(CommonSelectors.getCategoryById(parseInt(params.id!)));
  const { hide } = useMainProgressContext();

  useEffect(() => {
    if (category) {
      breadcrumbs.push({
        label: category.name,
        to: null,
      });

      hide();
      dispatch(Actions.resetArticles());
    }
  }, [category]);

  return (
    <>
      <SnackbarSettings
        hideSuccessMessage={true}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiArticlesRequestState}
      />
      <Title>{t('article.manage')}</Title>
      <Breadcrumbs title="article.manage" links={breadcrumbs} hide />
      <ArticleFilter
        categoryId={rootCategory ? (rootCategory.value as unknown as number) : undefined}
        category={category}
      />
      <ArticleDataGrid categoryId={category ? (category.value as unknown as number) : undefined} />
    </>
  );
};

export default ArticleList;
